/* jshint -W024 */
import Roles from '@/domain/rolesEnum';

const DashboardRoutes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      auth: true,
      roles: [Roles.BACKOFFICE, Roles.CLIENT],
      title: 'Dashboard',
      iconName: 'chart-line'
    },
    component: () => import('@/ui/views/internal/dashboard/Dashboard.vue')
  }
];

export default DashboardRoutes;
